import { useId } from 'vue'

import { parseError } from '@/libs/error'
import i18n from '@/libs/i18n'
import { PrintError } from '@/libs/toast'
import { FileMimeType } from '@/libs/mimeTypes'
import { useAppStore } from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'
import type { JWT } from '@/types/Common'
import type { Unit } from '@/types/Unit'

export const parseJwt = (token: string): JWT | null => {
    if (!token) return null

    const splitToken = token.split('.')
    if (splitToken.length !== 3) return null

    const payload = token.split('.')[1]
    if (!payload) return null

    return JSON.parse(atob(payload))
}

const generateRandomId = (prefix = ''): string => {
    prefix = prefix ? `${prefix}-` : ''
    return `${prefix}${useId()}`
}

const convertFloat = (val: number, decimalPlaces = 2): string => {
    if (val) return val.toLocaleString(undefined, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })
    return '0.00'
}

const chartColors: string[] = [
    '#FFC300', '#FF5733', '#C70039', '#900C3F',
    '#754043', '#9A8873', '#37423D', '#6A041D',
    '#845EC2', '#F9F871', '#946200', '#9E8152',
    '#F5B841', '#7A918D', '#005248', '#DEBA57',
    '#CF6969', '#C1554D', '#EAA44F', '#A00E29',
    '#A68D65', '#FB6884', '#DFE0DF', '#FB68CD'
]

const downloadAttachment = async(requestUrl: string, filename: string, checkDocumentType = false) => {
    const appStore = useAppStore()
    const fetchStore = useFetchStore()

    let fileType: string | undefined = 'pdf'

    appStore.startLoading()
    const { response, data, error } = await fetchStore.fetch(requestUrl).get().blob()
    if (response.value?.status === 200 && data.value) {
        const url = window.URL.createObjectURL(data.value)
        const link = document.createElement('a')
        link.href = url

        if (checkDocumentType) {
            fileType = FileMimeType[data.value.type]

            if (fileType && fileType.length > 0) link.setAttribute('download', `${filename}.${fileType}`)
            else link.setAttribute('download', filename)
        } else link.setAttribute('download', filename)

        document.body.appendChild(link)
        link.click()
    } else {
        PrintError(parseError(error.value, i18n.global.t('general.no_documents_to_download')))
    }
    appStore.stopLoading()
}

const getOwnerOrUser = (ownerOrUser: string): string => {
    if (ownerOrUser === 'L+U') return i18n.global.t('owner_or_user.owner_and_user')
    else if (ownerOrUser === 'L') return i18n.global.t('owner_or_user.owner')
    return i18n.global.t('owner_or_user.user')
}

const unitText = (unit: Unit | undefined) => {
    if (!unit) return ''
    let buildingNumber = ''
    let zaporedna = ''
    let stevStanovanja = ''
    if (unit.stev_stavbe.length > 0) buildingNumber = `- ${unit.stev_stavbe}`
    if (unit.zaporedna > 0) zaporedna = `- ${unit.zaporedna.toString()}`
    if (unit.stev_stanovanja > 0) stevStanovanja = `(${unit.stev_stanovanja.toString()})`
    return `${unit.naziv} ${buildingNumber} ${zaporedna} ${stevStanovanja}`
}

export { generateRandomId, convertFloat, chartColors, downloadAttachment, getOwnerOrUser, unitText }

export const MongoDBNullId = '000000000000000000000000'
